export default {
  walletBalance: "钱包余额",
  collect: "领取",
  approve: "授权",
  ticket: "许可证",
  category: "分类",
  sortBy: "排序",
  issue: "发行",
  confirm: "确认",
  detail: "详情",
  stakingType: "抵押",
  stakingTypeInfo: "为防止发行方恶意确认结果，请质押代币或当前NFT。",
  subscriptionAmount: "认购金额",
  subscription: "认购",
  subscribe: "购买",
  max: "最大",
  marketClosed: "市场已关闭",
  add: "增加",
  deposit: "充值",
  verifiedNFT: "查看已验证许可证",
  select: "选择",
  selected: "已选择",
  moreNFT: "获取更多许可证",
  forecastEvent: '事件',
  subscribeEndDate: '最后交易日',
  specifyLastTradingDate: "设置最后交易时间",
  specifyExpiryDate: '设置到期日期',
  endDate: '结束日期',
  validityPeriod: '到期日期',
  marketEndDate: '到期日期',
  liquidityMin: '最小流动性',
  premiumMin: "最低保费",
  paymentCurrency: "支付货币",
  defaultOdds: "默认杠杆",
  setDefaultOdds: "设置杠杆",
  minInvestAmout: "设置最低投资额",
  depositMargin: "添加流动性",
  totalPayment: "支付总额",
  rewards: "奖励",
  rewardRate: "奖励率",
  release: "释放",
  fee: "费用",
  marginFeeRate: "费率",
  cdsInfoOne: "发行预测产品时，需要质押保证金，设置默认杠杆和最低投资额。",
  cdsInfoTwo: "未参与的保证金可随时提取。",
  cdsInfoThree: "若超过1位用户选择对判定结果提出申诉，将启动社区治理机制以确定预测事件是否发生。",
  deposited: "已投入",
  issued: "已发行",
  depositedCDS: "已投资产品",
  totalProfit: "总收益",
  allOrDeposited: "总计/已投入",
  rewardsOrProfit: "奖励/收益",
  estimatedInvested: "预计/已投入",
  profit: "收益",
  yesterdayProfit: "昨日收益",
  status: "状态",
  eventConfirming: "事件确认中",
  appeal: "申诉",
  appealing: "申诉中",
  appealFailed: "申诉失败",
  occured: "已发生",
  notOccured: "未发生",
  governanceMechanism: "当申诉人数超过一人时，启动社区治理机制。",
  appealLimit: "申诉人数不超过一人。",
  waitResult: "等待申诉结果",
  frozenMargin: "冻结保证金",
  marginBalance: "保证金余额",
  balance: "余额",
  cash: '现金',
  createNew: '创建市场',
  withdraw: "提取",
  endTime: "距结束倒计时",
  guaranteeing: "进行中",
  guaranteeingEvent: "预测进行中",
  confirmsEventAdvance: "事件提前确认发生。",
  waitConfirmation: "事件等待确认。",
  triggerEvent: "事件已确认发生。",
  notTriggerEvent: "事件未发生。",
  defaultChallenging: "事件已发生，申诉中。",
  notDefaultChallenging: "事件未发生，申诉中。",
  defaultChallengeFailed: "事件已发生，申诉失败。",
  notDefaultChallengeFailed: "事件未发生，申诉失败。",
  defaultWaitingResult: "事件已发生，等待治理结果。",
  notDefaultWaitingResult: "事件未发生，等待治理结果。",
  defaultGovernanceMechanism: "治理机制确认事件已发生。",
  notDefaultGovernanceMechanism: "治理机制确认事件未发生。",
  cancel: "取消",
  defaultAhead: "提前发生",
  occur: "已发生",
  notOccur: "未发生",
  stakingToChallenge: "质押以申诉",
  challenged: "已申诉",
  checking: "审核中",
  fail: "失败",

  appealInfoOne: "如果你认为当前预测事件的判定与事实不符，可以“申诉”，启动治理机制以最终确定当前预测结果。",
  check: "查看",
  contentIllegal: "预测事件包含不合规内容，请修改后再发行",
  subscribed: "已投资产品",
  receivingCompensation: "待领取",
  received: "总赔付",
  receive: "领取",
  compensationAmount: "已发生赔付金额",
  liquidity: "流动性",
  injectLiquidity: "注入流动性",
  uRLContent: "链接/内容",
  resolutionSource: "判定来源",
  textareaInfo: "请简要描述该事件。",

  // Issue.vue 通知文案（顶层）
  issueMsgPleaseSelectLicense: "请选择许可证",
  issueMsgLicenseCannotBeStaked: "许可证不可质押",
  issueMsgNetworkNotConnected: "网络未连接",
  issueMsgEventEmpty: "事件内容为空",
  issueMsgSelectLicense: "请选择许可证",
  issueMsgLastTradingDateEmpty: "最后交易日为空",
  issueMsgExpirationDateEmpty: "到期日期为空",
  issueMsgOptionsEmpty: "选项不能为空",
  issueMsgOptionsLessThanTwo: "选项不能少于两个",
  issueMsgOptionEmpty: "选项内容不能为空",
  issueMsgOptionRepeated: "选项内容不能重复",
  issueMsgLastTradingDateGreaterThanToday: "最后交易日必须大于今天",
  issueMsgLastTradingDateGreaterThanExpirationDate: "最后交易日大于到期日",
  issueMsgLicenseError: "许可证错误",
  issueMsgTicketError: "凭证错误",
  issueMsgEventEndDateGreaterThanRentalEndDate: "事件结束日期 {eventEndDate} 晚于租赁结束日期 {rentalEndDate}",
  issueMsgInsufficientBalance: "余额不足",
  issueMsgTransactionFailed: "交易失败",
  issueMsgIssueSuccess: "发行成功",
  issueMsgTransactionCancelled: "交易已取消",

  donations: "捐赠",
  amount: "数量",

  short: {
    confirmsEventAdvance: "提前发生",
    waitConfirmation: "等待确认",
    defaultChallenging: "发生-申诉中",
    notDefaultChallenging: "未发生-申诉中",
    defaultChallengeFailed: "发生-申诉失败",
    notDefaultChallengeFailed: "未发生-申诉失败",
    defaultWaitingResult: "发生-治理中",
    notDefaultWaitingResult: "未发生-治理中",
    defaultGovernanceMechanism: "发生-治理确认",
    notDefaultGovernanceMechanism: "未发生-治理确认"
  },

  wallet: {
      openWallet: "打开钱包",
      connectWallet: "连接钱包",
      connectingWallet: '连接中',
      connectYourWallet: "连接钱包",
      disconnect: "断开连接",
      wrongNetwork: "网络错误"
  },
	
  NFT: {
    inputSearchText: "请输入搜索内容",
    donations: "捐赠",
    amount: "金额",
    description: "描述",
    getPrediLicense: "获取 Predi 许可证",
    referralRewards: "邀请奖励",
    mintYourLicence: "铸造你的许可证",
    usageRights: "使用权",
    issuePredictionProducts: "发行预测产品",
    governance: "治理",
    properties: "属性",
    tradable: "可交易",
    rentable: "可租赁",
    usable: "可使用",
    marketsToIssue: "可发行市场",
    times: "次",
    availableTimes: "可用次数",
    ticketId: "许可证编号",
    cancelRentHint: "该许可证正在出租，请先取消后再出售。",
    seeMore: "查看更多",
    sell: "出售",
    rent: "出租",
    // 新增：NFT 详情页用到的文案
    rules: "规则",
    payoff: "收益",
    details: "详情",
    licenseOwner: "许可证持有者",
    tokenId: "Token ID",
    getYourLicense: "获取你的许可证",
    issueTimesList: "发行次数列表",
    total: "总计",
    time: "时间",
    user: "用户",
    expiringDate: "到期日期",
    period: "期限",
    days: "天",
    unsold: "未售出",
    onSale: "NFT 正在出售。",
    licenseSaleRentable: "当前许可证可出售或出租。",
    licenseCanSell: "许可证可出售。",
    licenseUnsold: "许可证未出售。",
    selling: "出售中",
    pleaseInputValidPrice: "请输入有效价格",
    tabGetLicense: "获取许可证",
    issueTip: "每个许可证可发行10个预测产品",
    tabMyLicense: "我的许可证",
    price: "价格",
    prediLicense: "Predi 许可证",
    common: "普通",
    scarcity: "稀有",
    attributive: "属性",
    numbers: "发行数量",
    success: "成功",
    getNFT: "获取许可证成功",
    issueCDS: "发行 Predi 市场",
    buyNow: "立即购买",
    mintNow: "立即铸造",
    rule: "规则",
    comingSoon: "敬请期待！",
    type: "类型",
    from: "来自",
    to: "至",
    me: "我",
    rented: "已出租",
    sold: "已售出",
    bought: "已购买",
    boughtProducts: "已购买产品",
    investedProducts: "已投资产品",
    issuedProducts: "已发行产品"
  },
  // 顶层 claim（模板按 claim.* 引用）
  claim: {
    title: "免费领取 PRDs",
    subtitle: "轻松一点，获取你的 PRDs 代币",
    walletAddress: "钱包地址",
    status: "状态",
    connectWalletFirst: "请先连接钱包",
    eligibility: {
      claimed: "你已领取过空投",
      eligible: "你可以领取空投",
      error: "查询领取资格时出错"
    },
    button: {
      claim: "领取空投",
      alreadyClaimed: "已领取",
      connect: "连接"
    },
    footerNotice: "每个钱包仅可领取一次。请确保连接到正确的网络。",
    messages: {
      connectFirst: "请先连接钱包",
      claimSuccess: "领取空投成功！",
      claimFailed: "领取空投失败，请稍后重试",
      txCancelled: "交易已取消",
      onlyOnce: "每个用户仅可领取一次",
      insufficientBalance: "合约余额不足，请稍后重试"
    }
  },
  positions: "持仓",
  options: "选项",
  all: "全部",
  volume: "成交量",
  newest: "最新",
  pending: "待定",
  audit: "审核",
  loading: "加载中",
  home: "首页",
  market: "市场",
  markets: "市场",
  portfolio: "投资组合",
  language: '语言',
  empowering: "赋能引领者，预测未来",
  myPositions: "我的持仓",
  challengeCredit: "申诉信用",
  challengeStatus: "申诉状态",
  succeed: "成功",
  wait: "等待",
  return: "返回",
  createYourOwnMarket: "创建你的市场",
  waitChallenge: "事件等待申诉。",
  complaintCountdown: "申诉倒计时",
  setResult: "设置结果",
  insufficientFunds: "资金不足",
  buyTicket: "购买许可证",
  buy: "购买",
  listYourToken: "上架你的代币",
  description: "描述",
  setResultModalTitle: "设置结果：",
  cancelModalTitle: "取消",
  cancelIrreversible: "取消不可逆。",
  challengeModalTitle: "申诉",
  challengeStakeIntro: "若事实存在偏差，将返还给你。",
  challengeStakeButton: "使用 PRDS 发起申诉",
  history: "历史",
  waitingGovernanceResult: "事件等待治理机制结果。",
  eventFinished: "事件已结束。",
  predictionToken: "预测代币",
  issuerResult: "发行方结果",
  daoResult: "DAO 结果",
  licenses: "许可证",
  prediLicense: "Predi 许可证",
  issuableQuantity: "可发行数量",
  disabled: "不可用",
  battleImage: "佐证图片",
  upload: "上传",
  showSample: "查看示例",
  battleInformation: "争议佐证",
  baseToken: "基础代币",
  collateral: "抵押",
  currentLicense: "当前许可证",
  predictionProject: "预测项目：",
  issueExpireIntro: '在到期时间，选择正确选项的人将根据其参与份额瓜分产品池中的代币。',
  issueParticipateUntil: "用户可参与该产品直到",
  issueConfirmAdvance: '如果事件在到期时间前发生，发行方可提前确认结果。',
  issueChallengeWithin7Days: "如果参与者对发行方确认的事件结果有异议，可在确认后的7天内点击“申诉”。",
  issueAttention: "注意：Predi 致力于促进娱乐与社交体验。本平台严禁任何形式的赌博相关活动。",
  eventSampleTitle: "事件",
  issueSampleCrypto: "[加密] 2025 年末比特币的价格区间会是多少？",
  issueSampleFinance: "[金融] 2025 年 Q3 美联储的利率决议会是什么？",
  issueSampleTechnology: "[科技] 哪家公司将推出首款完全自主的 AI 驱动机器人助手？",
  issueSampleSports: "[体育] 哪支球队将赢得 2026 年 FIFA 世界杯？",
  issueSampleSociety: "[社会] 哪个社交平台将在 2025 年拥有最多月活用户？",
  issueSampleOthers: "[其他] 俄乌战争何时结束？",
  predictionToken: "预测代币",
  license: "许可证",
  issuer: "发行方",
  issuerProfit: "发行方收益",
  recycleTicket: "回收许可证",
  eventCancelled: "事件已取消。",
  challenge: "申诉",
  share: "分享",
  USDT: "USDT"

}
